import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import ScrollReveal, { StaggerContainer, StaggerItem } from "@/components/ScrollReveal";

const FAQS = [
  {
    q: "¿Quién atiende mi operación?",
    a: "Un asesor certificado con experiencia en operaciones de alto valor. La misma persona desde el diagnóstico hasta la firma — sin transferencias entre áreas ni cambios de interlocutor.",
  },
  {
    q: "¿Qué respaldo tiene Brillo Finance?",
    a: "Operamos como franquicia Creditaria, la red de intermediación hipotecaria con mayor trayectoria en México. Nuestro equipo mantiene certificación vigente y capacitación continua con cada institución financiera con la que trabajamos.",
  },
  {
    q: "¿Cómo acceden a condiciones que no están publicadas?",
    a: "Las instituciones reservan estructuras específicas para operaciones de alto valor. Mantenemos esa relación con más de 15 instituciones bancarias y no bancarias.",
  },
  {
    q: "¿Por qué la asesoría no tiene costo?",
    a: "La institución que coloca el crédito cubre los honorarios al formalizar. Es el modelo estándar de intermediación hipotecaria profesional en México y en los principales mercados internacionales.",
  },
  {
    q: "¿Qué sucede con mi información?",
    a: "Tu expediente se maneja bajo los estándares de confidencialidad del segmento privado de cada institución. Solo se comparte con las instituciones que participan en tu operación, con tu autorización expresa.",
  },
  {
    q: "¿Cómo funciona la deducibilidad en hipotecas superiores a $7.5M?",
    a: "La deducción de intereses reales aplica hasta 750,000 UDIs (~$6.8M MXN en 2026). Para hipotecas superiores, se calcula sobre la fracción proporcional. Integramos este análisis al costo real del crédito desde el inicio, en coordinación con tu contador.",
  },
  {
    q: "¿Pueden estructurar hipotecas para perfiles con ingresos en dólares o binacionales?",
    a: "Sí. Es uno de los perfiles más frecuentes en el segmento premium de Jalisco. Existen instituciones con modelos de análisis específicos para ingresos en divisa extranjera. Identificamos las opciones y coordinamos el expediente en el formato adecuado.",
  },
];

export default function FAQSection({ onCtaClick }) {
  return (
    <section id="faq" className="py-24 md:py-32" style={{ background: "#1F1F1F" }} data-testid="faq-section">
      <div className="bf-container">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
          {/* Left column */}
          <div className="lg:col-span-4">
            <ScrollReveal preset="fadeLeft" duration={0.8}>
              <div className="bf-teal-line mb-6" />
              <p className="bf-eyebrow">Quiénes somos</p>
              <h2 className="mt-4 font-serif text-3xl md:text-4xl tracking-tight text-white leading-tight">
                Preguntas<br />frecuentes
              </h2>
              <div className="mt-10">
                <button
                  onClick={onCtaClick}
                  data-testid="faq-cta-button"
                  className="bf-btn-coral px-7 py-3.5"
                >
                  Habla con un asesor
                </button>
              </div>
            </ScrollReveal>
          </div>

          {/* Right column – Accordion */}
          <div className="lg:col-span-8">
            <StaggerContainer stagger={0.08} threshold={0.1}>
              <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                {FAQS.map((item, i) => (
                  <StaggerItem key={item.q} preset="fadeUp" duration={0.6}>
                    <AccordionItem
                      value={`item-${i}`}
                      className="border-b"
                      style={{ borderColor: "rgba(255,255,255,0.08)" }}
                      data-testid={`faq-item-${i}`}
                    >
                      <AccordionTrigger
                        className="text-left font-serif text-base md:text-lg text-white hover:no-underline py-6"
                      >
                        {item.q}
                      </AccordionTrigger>
                      <AccordionContent className="text-sm leading-relaxed pb-6" style={{ color: "rgba(255,255,255,0.45)" }}>
                        {item.a}
                      </AccordionContent>
                    </AccordionItem>
                  </StaggerItem>
                ))}
              </Accordion>
            </StaggerContainer>
          </div>
        </div>
      </div>
    </section>
  );
}
